module.exports = __webpack_public_path__ + "static/img/smoke_e.245a8d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/smoke_e.png
// module id = rx+J
// module chunks = 208